import { render } from "./IconGridItem.vue?vue&type=template&id=98bbd24a&scoped=true"
import script from "./IconGridItem.vue?vue&type=script&lang=js"
export * from "./IconGridItem.vue?vue&type=script&lang=js"

import "./IconGridItem.vue?vue&type=style&index=0&id=98bbd24a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98bbd24a"]])

export default __exports__